module.exports = __webpack_public_path__ + "static/media/logo_3x.e17413eb.png";